namespace e5 {
    /**
     * base on: https://stackoverflow.com/questions/23885255/how-to-remove-ignore-hover-css-style-on-touch-devices
     */
    export class PointerDetector {
        private _isTouchDevice: boolean = true;

        private static _instance: PointerDetector = null;
        public static get(): PointerDetector {
            if (!this._instance) {
                this._instance = new PointerDetector();
            }
            return this._instance;
        }
        private constructor() {
            let lastTouchTime = 0

            let checkMouseEvent = () => {
                if (Date.now() - lastTouchTime < 500) {
                    return;
                }
                this.isTouchDevice = false;
            }

            let checkTouchEvent = () => {
                lastTouchTime = Date.now();
                this.isTouchDevice = true;
            }

            let checkPointerEvent = (e: PointerEvent) => {
                this.isTouchDevice = e.pointerType == "touch";
            };

            if (window.PointerEvent) {
                document.addEventListener("pointerenter", checkPointerEvent, true);
                document.addEventListener("pointerdown", checkPointerEvent, true);
            } else {
                document.addEventListener('touchstart', checkTouchEvent, true);
                document.addEventListener('touchmove', checkTouchEvent, true);
                document.addEventListener('mousemove', checkMouseEvent, true);
            }

            //Initial check
            if ('ontouchstart' in document.documentElement
                || navigator.maxTouchPoints > 0
                || navigator.msMaxTouchPoints > 0) {
                this._isTouchDevice = true;
                document.body.setAttribute("data-device", "touch");
            } else {
                this._isTouchDevice = false;
                document.body.setAttribute("data-device", "mouse");
            }
        }

        public get isTouch(): boolean {
            return this._isTouchDevice;
        }

        private get isTouchDevice(): boolean {
            return this._isTouchDevice;
        }

        private set isTouchDevice(value: boolean) {
            if (this._isTouchDevice == value) {
                return;
            }
            this._isTouchDevice = value;

            if (value) {
                document.body.setAttribute("data-device", "touch");
            } else {
                document.body.setAttribute("data-device", "mouse");
            }
        }
    }
}